/* eslint-disable max-lines */


import $ from 'jquery';
import ko from 'knockout';
import { first } from '../../../../utils/array';
import { propEquals } from '../../../../utils/object';
import ProductClassViewModel from '../../viewmodels/productclassviewmodel';
import SupplementProductViewModel from './productviewmodel';
import selectProductFromURLParam from '../../shared/selectproductfromurl';

const accountTypes = {
    UNKNOWN: 0,
    HORSE: 1,
    DOG: 2,
    CAT: 3,
    ME: 5,
    NOT_ANIMAL: 6
};

function SupplementViewModel(data, config) {
    ProductClassViewModel.call(this, data, config);

    let images = this.images(),
        products,
        supplies,
        compareProductData,
        autoShipSubscribe,
        querystring = smartPak.url.parseQueryString(location.search),
        matchingVideo;

    const PROZYME_ID = 2933;

    this.unitImages = images.filter(propEquals('type', 'unit'));

    products = this.products()
        .filter(function (product) {
            return typeof product.price !== 'function' ? product.price : product.price();
        })
        .map(
            function (product) {
                product.unitImage = this.getImageByUnitType(
                    product.type() === 'supplement' ? 'scoops' : product.unit()
                );
                return new SupplementProductViewModel(product, this.excludeFromPromo());
            }.bind(this)
        );

    supplies = products.filter(propEquals('type', 'tes'));

    this.products(products);

    this.badges = images.filter(propEquals('type', 'badge'));
    this.banner = first(images, propEquals('type', 'banner'));
    this.productLabelImage = first(images, propEquals('type', 'label'));
    this.supplementPileImage = first(images, propEquals('type', 'supplement-pile'));
    this.hasSmartPak = products.some(propEquals('type', 'supplement'));
    this.hasPortionPak = products.some(propEquals('type', 'portionpak'));
    this.hasSupplies = supplies.length > 0;

    this.instructions = instructions(
        this.instructions,
        first(images, propEquals('type', 'instructions')),
        this.hasSmartPak
    );
    this.analysis = analysis(this.analysis, products);
    this.selectedVideo = ko.observable();
    this.isCanine = this.recipientType() === 'dog';
    this.defaultImage = this.productImages[0];
    this.hasCanineSmartPak = this.isCanine && this.hasSmartPak;
    this.hasComparisonCharts = ko.observable(false);
    this.currentSelection = ko.observable();
    this.disableAddToCart = ko.observable(false);
    this.accountCannotAddCbd = ko.observable(false);

    this.unitImages.forEach(
        function (image) {
            if (image.attributes.unit() === 'scoops') {
                image.url(this.defaultImage.url());
            }
        }.bind(this)
    );

    this.carouselImages = getCarouselImagesInOrder(
        this.productImages,
        this.unitImages,
        this.hasCanineSmartPak || this.hasPortionPak,
        this.productLabelImage
    );

    this.isPerkProduct = ko.computed(
        function () {
            var product = this.selectedProduct(),
                PERK_ELIGIBLE_THRESHOLD = 40;

            return (
                !this.isCanine &&
                !!product &&
                product.daysSupply() >= 1 &&
                parseFloat(product.cost()) > PERK_ELIGIBLE_THRESHOLD
            );
        }.bind(this)
    );

    this.selectedImage(this.defaultImage);

    this.doseDisplayOpen = ko.observable(false);

    this.toggleDoseDisplay = function () {
        this.doseDisplayOpen(!this.doseDisplayOpen());
    };

    this.formName = ko.computed(
        function () {
            return this.currentSelection() === 'supply'
                ? 'addSupplyForm'
                : !this.isCanine
                    ? 'addSmartPakForm'
                    : 'addPortionPakForm';
        }.bind(this)
    );

    this.formId = ko.computed(
        function () {
            return this.currentSelection() === 'pak'
                ? !this.isCanine
                    ? 'addSmartPakForm'
                    : 'addPortionPakForm'
                : 'addSupplyForm';
        }.bind(this)
    );

    this.checkSubscriptionStatus = function (recipient) {
        this.disableAddToCart(true);

        if (!recipient || !this.containsCbd()) {
            this.accountCannotAddCbd(false);
            this.disableAddToCart(false);
        } else if (recipient.AccountType === accountTypes.HORSE) {
            this.getSubscriptionCbdStatus("Equine", recipient.AccountId)
                .then(res => {
                    this.accountCannotAddCbd(res);
                    this.disableAddToCart(false);
                });
        } else if (recipient.AccountType === accountTypes.DOG) {
            this.getSubscriptionCbdStatus("Canine", recipient.AccountId)
                .then(res => {
                    this.accountCannotAddCbd(res);
                    this.disableAddToCart(false);
                });
        } else {
            this.disableAddToCart(false);
        }
    };

    this.getSubscriptionCbdStatus = function (animalType, accountId) {
        return new Promise(resolve => {
            const promises = ['Billing', 'Shipping'].map(addressType => {
                return fetch(
                    `/api/Restriction/GetCbd${addressType}AddressRestrictionFor${animalType}SmartPakSubscription?accountId=${accountId}`
                ).then(res => res.text());
            });

            Promise.all(promises).then(([hasBillingRestriction, hasShippingRestriction]) => resolve(hasBillingRestriction === 'true' || hasShippingRestriction === 'true'));
        });
    };

    if (this.extraInformation && this.extraInformation.comparisonData) {
        try {
            compareProductData = JSON.parse(this.extraInformation.comparisonData());
            this.hasComparisonCharts(true);
            // eslint-disable-next-line no-unused-vars
        } catch (e) {
            this.hasComparisonCharts(false);
        }

        if (compareProductData && compareProductData.products.length) {
            var productCompareIds = compareProductData.products.map(function (product) {
                return product.id;
            });

            compareProductData.products = compareProductData.products.map(function (product) {
                return new ComparisonProduct(product);
            });

            this.extraInformation.comparisonData(compareProductData);

            smartPak.api.product.getProductClassDTOList(productCompareIds).done(
                function (data) {
                    if (data.length) {
                        data.forEach(function (productData) {
                            compareProductData.products
                                .filter(function (compareProduct) {
                                    return compareProduct.id === productData.Id;
                                })
                                .forEach(function (compareProduct) {
                                    compareProduct.imagePath(productData.ImagePath + '?width=200');
                                    compareProduct.name(productData.Name);
                                    compareProduct.url(productData.Url);
                                });
                        });
                    }
                }.bind(this)
            );
        }
    }

    if (this.hasSmartPak || this.hasPortionPak) {
        this.canShowFromPriceLabel = ko.computed(() => {
            var product = this.selectedProduct();

            return (
                product &&
                !product.hasCustomRetailOption &&
                ((product.isSmartPak &&
                    ((this.dosingDescriptions.length > 0 && !this.selectedDosingDescription()) ||
                        (product.hasOnlyCustomOption && !product.selectedOption()))) ||
                    (product.isPortionPak && this.selectedPortionPakOption && !this.selectedPortionPakOption()))
            );
        });

        this.paks = products.filter(propEquals('type', this.hasPortionPak ? 'portionpak' : 'supplement'));
        this.dosingDescriptions = this.paks
            .filter(dosingDescription)
            .map(dosingDescription)
            .sort(dosingDescriptionSorter);
        this.showDoseCaption = this.id() === PROZYME_ID;
        this.hasDosingDescription = this.dosingDescriptions.length > 0;
        this.hasSmartPakOrPortionPak = this.hasSmartPak || (this.hasPortionPak && !this.hasDosingDescription);
        this.hasPortionPakWithDosing = this.hasPortionPak && this.hasDosingDescription;
        this.postPakURL = '/addtocart/' + this.id() + (this.hasPortionPak ? '/AddPortionPak' : '/AddSmartPak');
        this.selectedPak = ko.observable(this.findSmartPakableProduct());
        this.selectedDosingDescription = ko.observable();

        this.canShowChangeDose = ko.computed(() => {
            var pak = this.selectedPak();

            return (
                !this.hasPortionPakWithDosing &&
                pak && !pak.hasSingleDoseTypeOption &&
                (!this.hasDosingDescription || (this.hasDosingDescription && !!this.selectedDosingDescription()))
            );
        });

        this.showDosingOptions = ko.computed(() => {
            var pak = this.selectedPak();

            return (
                this.hasPortionPakWithDosing ||
                (pak && pak.hasSingleDoseTypeOption && pak.hasOnlyCustomOption) ||
                (this.doseDisplayOpen() &&
                    pak &&
                    !pak.hasSingleDoseTypeOption &&
                    ((this.hasDosingDescription && !!this.selectedDosingDescription()) || !this.hasDosingDescription))
            );
        });

        this.selectedPak.subscribe(
            function (pak) {
                if (pak) {
                    this.currentSelection('pak');
                    this.selectedProductId(pak.id());
                }
            }.bind(this)
        );

        this.selectedProduct.subscribe(product => {
            if (product && !/portionpak|supplement/gi.test(product.type())) {
                this.showImage(this.getImageByUnitType(this.selectedProduct().unit()));
            } else if (!this.isCanine) {
                this.showImage(this.getImageByUnitType('scoops'));
            }
        });

        if (this.hasPortionPakWithDosing || this.hasSmartPak) {
            this.selectedDosingDescription.subscribe(
                function (description) {
                    this.selectedPak(
                        description ? this.findPakByDosingDescription(description) : this.findSmartPakableProduct()
                    );
                }.bind(this)
            );
        }
    }

    if (this.hasPortionPak) {
        this.selectedPortionPakOption = ko.observable();

        this.selectedPortionPakOption.subscribe(
            function (description) {
                this.selectedPak(
                    description ? this.findPakByDosingDescription(description) : this.findSmartPakableProduct()
                );
            }.bind(this)
        );

        this.feedingChartData = ko.observableArray();

        getFeedChartData(this.id()).done(
            function (chartData) {
                this.feedingChartData(formatFeedingChartData(JSON.parse(chartData), this.products()));
            }.bind(this)
        );
    }

    if (this.hasSmartPakOrPortionPak) {
        this.smartPakableProduct = this.findSmartPakableProduct();
        this.isFarriersFormulaDS = isFarriersFormula(this.id());

        if (this.isColiCareEligible && this.isColiCareEligible()) {
            this.colicare = {
                shouldShowOptInForm: ko.observable(false),
                shouldShowMessage: ko.observable(true),
                setMessage: function () {
                    this.shouldShowOptInForm(!this.policyExists());
                    this.shouldShowMessage(this.policyExists() && this.policyWasDenied());
                },
                policyExists: ko.observable(false),
                policyWasDenied: ko.observable(true)
            };

            this.selectedRecipientName.subscribe(
                function (name) {
                    if (!name) {
                        return;
                    }

                    var recipient = first(this.pakRecipients(), propEquals('Name', name));

                    if (recipient) {
                        getColicarePolicyByRecipientId(recipient.AccountId).done(
                            function (data) {
                                if (!data) {
                                    return;
                                }

                                this.policyExists(data.PolicyExists);
                                this.policyWasDenied(data.PolicyExists && data.DenialReason.length);
                                this.setMessage();
                            }.bind(this.colicare)
                        );
                    } else {
                        this.colicare.setMessage();
                    }
                }.bind(this)
            );
        }

        this.canShowCostPerDay = ko.computed(
            function () {
                var pak = this.selectedPak(),
                    selectedOption = pak && pak.selectedOption();

                if (this.hasSmartPak) {
                    return (
                        (!!selectedOption && selectedOption.type() !== 'custom') ||
                        (!!selectedOption && selectedOption.type() === 'custom' && !!pak.selectedFeedingTime())
                    );
                }
                return (
                    (!!selectedOption && selectedOption.type() !== 'custom') ||
                    (!!selectedOption && selectedOption.type() === 'custom')
                );
            }.bind(this)
        );

        this.selectedRecipient.subscribe(recipient => {
            this.checkSubscriptionStatus(recipient);
        });
    }

    if (this.hasSupplies) {
        this.postURL = '/addtocart/' + this.id() + '/AddSupply';
        this.supplies = supplies.sort(function (a, b) {
            return a.cost() - b.cost();
        });
    }

    this.selectedProductId.subscribe(
        function (id) {
            this.selectedProduct(first(this.products(), propEquals('id', +id)));
        }.bind(this)
    );

    this.selectedProduct.subscribe(
        function (product) {
            $('.forRecipientMessage').hide();
            if (product) {
                var onlyAts = false;

                if (autoShipSubscribe) {
                    autoShipSubscribe.dispose();
                }
                autoShipSubscribe = product.isAutoShip.subscribe(
                    function (autoship) {
                        this.updateProductsAutoShip(onlyAts ? true : autoship);
                    }.bind(this)
                );

                if (product.isPortionPak || (this.isCanine && product.isSmartPak)) {
                    onlyAts = true;
                    product.isAutoShip(true);
                }

                if (!/portionpak|supplement/gi.test(product.type())) {
                    this.currentSelection('supply');
                    if (product.daysSupplyInput && !product.daysSupplyInput()) {
                        product.daysSupplyInput(28);
                    }
                } else {
                    this.currentSelection('pak');

                    if (product.type() === 'portionpak') {
                        product.isAutoShip(true);
                    }
                }

                if (!product.isEligibleForSubscription()) {
                    product.isAutoShip(false);
                }

                const attributesMatchingImage = this.findImageByProductAttributes(product);

                if (attributesMatchingImage) {
                    this.selectedImage(attributesMatchingImage);
                    return;
                }

                if (product.unitImage) {
                    this.selectedImage(product.unitImage);
                }
            }
        }.bind(this)
    );

    this.selectedProductId(+this.products()[0].id());
    this.selectedProduct().isAutoShip(this.isEligibleForSubscription());
    this.updateProductsAutoShip(this.isEligibleForSubscription());

    if (this.selectedProduct().isSmartPak || this.selectedProduct().isPortionPak) {
        if (!this.smartPakableProduct) {
            this.smartPakableProduct = this.findSmartPakableProduct();
        }

        this.selectedProductId(this.smartPakableProduct.id());
        this.selectedPak(this.smartPakableProduct);
    }

    if (querystring && querystring.video) {
        matchingVideo = this.videos().filter(function (video) {
            return video.id === querystring.video;
        })[0];

        if (matchingVideo) {
            this.showVideo(matchingVideo);
        }
    }

    if (location.search) {
        selectProductFromURLParam(this);
    }
}

$.extend(SupplementViewModel.prototype, {
    findImageByProductAttributes: function (product) {
        if (!product.attributes || !Object.entries(product.attributes).length) {
            return null;
        }

        const imageWithAttributeMatches = this.imageWithAttributeMatches(this.productImages, product.attributes);

        return imageWithAttributeMatches.matches ? imageWithAttributeMatches.image : null;
    },
    findPakByDosingDescription: function (description) {
        return first(this.paks, propEquals('dosingDescription', description));
    },
    findSmartPakableProduct: function () {
        let pakAtZeroIndex = this.paks.length ? this.paks[0] : undefined;
        return !pakAtZeroIndex ||
            !pakAtZeroIndex.isPortionPak ||
            (pakAtZeroIndex.isPortionPak && !pakAtZeroIndex.hasCustomRetailOption)
            ? pakAtZeroIndex
            : this.findPakByDosingDescription(pakAtZeroIndex.customRetailOption.description().toString());
    },
    showVideo: function (video) {
        this.selectedVideo(video);
    },
    showImage: function (image) {
        this.selectedVideo(undefined);
        this.selectedImage(image);
    },
    getImageByUnitType: function (unit) {
        var image = first(this.unitImages, function (img) {
            return img.attributes && img.attributes.unit() === unit;
        });
        return image ? image : this.defaultImage;
    },
    updateProductsAutoShip: function (autoship) {
        this.products().forEach(function (item) {
            var currentAutoShipValue = item.isAutoShip();
            if (autoship !== currentAutoShipValue) {
                item.isAutoShip(autoship);
            }
        });
    }
});

function ComparisonProduct(product) {
    this.id = product.id;
    this.imagePath = ko.observable('');
    this.name = ko.observable('');
    this.url = ko.observable('');
    this.attributes = ko.observableArray(product.attributes.map(function (attribute) {
        addColorToAttribute(attribute);
        attribute.name = attribute.name.replace(
            /(herb-free)/gi,
            '<span class="caption">$1</span>'
        );
        return attribute;
    }));
}

function addColorToAttribute(attribute) {
    var compareColors = [
        { attribute: 'Joint', color: '#002b5c' },
        { attribute: 'Senior Joint', color: '#002b5c' },
        { attribute: 'Senior Joint Herb-free', color: '#002b5c' },
        { attribute: 'Hoof', color: '#00728f' },
        { attribute: 'Skin & Coat', color: '#9266A1' },
        { attribute: 'Hindgut', color: '#BC5B00' },
        { attribute: 'Tendon & Ligament', color: '#a30046' },
        { attribute: 'Stomach', color: '#007EB3' },
        { attribute: 'Temperament', color: '#6c217f' },
        { attribute: 'Adult Horses', color: '#00703c' },
        { attribute: 'None or Light Work', color: '#00703c' },
        { attribute: 'Moderate to Heavy Work', color: '#00703c' },
        { attribute: 'Senior Horses', color: '#00703c' }
    ];

    attribute.color = '#000';
    compareColors.forEach(function (compareColor) {
        if (compareColor.attribute.toLowerCase() === attribute.name.toLowerCase()) {
            attribute.color = compareColor.color;
        }
    });
}

function formatFeedingChartData(data, products) {
    return data.map(function (item) {
        item.products = item.products.map(function (id) {
            var product = first(products, propEquals('id', id));

            return {
                dose: product.dosingDescription()
            };
        });

        return item;
    });
}

function getFeedChartData(id) {
    return $.get('/productclasspage/' + id + '/GetPortionPakSuggestedFeedingChart');
}

function dosingDescriptionSorter(a, b) {
    return +a.split(' ')[0] < +b.split(' ')[0] ? -1 : 1;
}

function dosingDescription(product) {
    return product.dosingDescription && product.dosingDescription();
}

function getColicarePolicyByRecipientId(id) {
    return $.get('/api/coliCareDetail/getColiCarePolicyInfoByRecipient/' + id).then(function (data) {
        return data.Status === smartPak.HTTP_STATUS_OK ? data.Content : undefined;
    });
}

function isFarriersFormula(id) {
    var FARRIES_FORMULA_ID = 4675;
    return id === FARRIES_FORMULA_ID;
}

function analysis(analysis, products) {
    var pakProduct = first(products, propEquals('type', 'supplement')),
        maintenanceDose = !pakProduct ? null : first(pakProduct.dosingInfo(), propEquals('type', 'maintenance'));

    analysis.maintenanceDoseDescription = maintenanceDose ? maintenanceDose.description() : undefined;

    analysis.hasPerPoundIngredient =
        !analysis.ingredients().every(propEquals('amountPerPound', '')) &&
        analysis.ingredients().every(propEquals('amountPerServing', ''));

    analysis.hasSupportingText = !!analysis.ingredientsText() || !!analysis.secondaryHeading();

    analysis.ingredients().forEach(ingredient => {
        const needsWhitespaceToWrapInUI = /(\w)\/(\w)/gi,
            amountPerServing = ingredient.amountPerServing();

        if (needsWhitespaceToWrapInUI.test(amountPerServing)) {
            ingredient.amountPerServing(amountPerServing.replace(needsWhitespaceToWrapInUI, '$1 / $2'));
        }
    });

    analysis.keyIngredients(sortKeyIngredients(analysis.keyIngredients()));

    return analysis;
}

function sortKeyIngredients(keyIngredients) {
    var nulls = keyIngredients.filter(ingredient => ingredient.sortOrder === null);

    if (nulls.length) {
        nulls.forEach(item => keyIngredients.splice(keyIngredients.indexOf(item), 1));
        return keyIngredients.sort(byProp('sortOrder')).concat(nulls.sort(byProp('name')));
    }

    return keyIngredients.sort(byProp('sortOrder'));
}

function byProp(name) {
    return function (a, b) {
        return a[name]() > b[name]() ? 1 : -1;
    };
}

function instructions(instructions, image, hasSmartPak) {
    instructions = instructions || {};

    var dosing = instructions.dosing && instructions.dosing();

    instructions.hasWeight = !!dosing && !dosing.every(propEquals('weight', ''));
    instructions.hasLoading = !!dosing && !dosing.every(propEquals('loading', ''));
    instructions.hasMaintenance = !!dosing && !dosing.every(propEquals('maintenance', ''));
    instructions.image = image;
    instructions.showBanner =
        !image && !!dosing && (dosing.length > 0 || instructions.additionalInstructions !== '') && hasSmartPak;

    instructions.hasInstructions =
        instructions.dosing().length || !!instructions.additionalInstructions() || !!instructions.image;

    return instructions;
}

function getCarouselImagesInOrder(productImages, unitImages, hasCanineSmartPak, productLabelImage) {
    var defaultImage = productImages[0],
        alternateImages = productImages.slice(1),
        defaultImageType = defaultImage.type(),
        carouselImages = [];

    if (defaultImageType !== 'product' || defaultImageType === 'product' && (hasCanineSmartPak || !unitImages.length)) {
        carouselImages = carouselImages.concat(defaultImage);
    }

    carouselImages = carouselImages.concat(findUnitImagesInOrder(unitImages, getPreferredTypeOrder(unitImages)));

    if (productLabelImage) {
        carouselImages = carouselImages.concat([productLabelImage]);
    }

    if (alternateImages.length > 0) {
        carouselImages = carouselImages.concat(alternateImages);
    }

    return carouselImages;
}

function getPreferredTypeOrder(unitImages = []) {
    const promotedTypes = ['scoops', 'buckets', 'bags', 'tubes'];
    const distinctUnitTypes = [...new Set(unitImages.map(image => image.attributes.unit()))];
    const foundPromotedTypes = promotedTypes.filter(type => distinctUnitTypes.includes(type));
    const remainingTypes = distinctUnitTypes.filter(type => !foundPromotedTypes.includes(type));

    return foundPromotedTypes.concat(remainingTypes.sort());
}

function findUnitImagesInOrder(unitImages = [], typesInOrder = []) {
    return typesInOrder.reduce((arr, type) => {
        const unitImage = unitImages.find(image => image.attributes.unit() === type);

        if (unitImage) {
            arr.push(unitImage);
        }

        return arr;
    }, []);
}

export default SupplementViewModel;

export const unitImageHelpers = {
    getPreferredTypeOrder,
    findUnitImagesInOrder
};
